import React from 'react';
import { useSEO, generateWebsiteSchema, generateOrganizationSchema, generateBreadcrumbSchema } from '../utils/seo';

interface SEOWrapperProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  type?: string;
  schema?: any;
  breadcrumbs?: { name: string; url: string }[];
}

export const SEOWrapper: React.FC<SEOWrapperProps> = ({
  children,
  title,
  description,
  keywords,
  image,
  type,
  schema,
  breadcrumbs
}) => {
  // Combine schemas
  const combinedSchema = schema || generateWebsiteSchema();
  const schemasArray = [combinedSchema, generateOrganizationSchema()];
  
  if (breadcrumbs && breadcrumbs.length > 0) {
    schemasArray.push(generateBreadcrumbSchema(breadcrumbs));
  }

  const finalSchema = {
    "@context": "https://schema.org",
    "@graph": schemasArray
  };

  useSEO({
    title,
    description,
    keywords,
    image,
    type,
    schema: finalSchema
  });

  return <>{children}</>;
};
